import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { OrganizationBoutAttribute } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { map } from 'rxjs/operators';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get organizationBoutAttributes
 */
@Injectable()
export class OrganizationBoutAttributeService {
    // private cachedOrganizationBoutAttributes: OrganizationBoutAttribute[] = null;
    private cachedDataMap: { [apiRequest: string]: OrganizationBoutAttribute[]; } = {};

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all organizationBoutAttributes
     */
    public getIndex(queryParams: string[] = [], forceRefresh: boolean = false)
    : Observable<OrganizationBoutAttribute[]> {
        const apiUrl: string = this.getApiUrl(null, queryParams);

        if (!forceRefresh &&
            this.cachedDataMap[apiUrl]) {
            // if `cachedOrganizationBoutAttributes` is available just return it as `Observable`
            return observableInSeparateThread(
                this.cachedDataMap[apiUrl].map((o: OrganizationBoutAttribute) => o.clone()),
            );
        }
        // Make the http request
        return this.http.get(apiUrl).pipe(map((response: IJsonApiResponse) => {
            const bodyData: any = response.data ?? [];
            const organizationBoutAttributes: OrganizationBoutAttribute[] = [];
            for (const organizationBoutAttribute of bodyData) {
                organizationBoutAttributes.push((new OrganizationBoutAttribute())
                    .deserialize(organizationBoutAttribute));
            }

            this.cachedDataMap[apiUrl] = organizationBoutAttributes.map((o: OrganizationBoutAttribute) => o.clone());

            return organizationBoutAttributes;
        }));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(includes: string[], queryParams: string[] = null): string {
        let url: string = `${this.http.configService.getApiBaseUrl()}/organization-bout-attributes/`;
        url += this.http.getQueryParameters(includes, queryParams);

        return url;
    }
}
